import { useSite } from '../context/SiteContext';

const WhatsAppIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M20.52 3.48A11.94 11.94 0 0 0 12.01 0C5.4 0 .04 5.36.04 11.97c0 2.11.55 4.17 1.6 5.98L0 24l6.22-1.63a11.9 11.9 0 0 0 5.78 1.47h.01c6.62 0 11.98-5.36 11.98-11.97 0-3.2-1.24-6.2-3.47-8.39zM12 21.79a9.83 9.83 0 0 1-5-1.36l-.36-.21-3.7.97.99-3.6-.24-.37a9.82 9.82 0 0 1-1.51-5.25c0-5.44 4.42-9.86 9.86-9.86 2.63 0 5.11 1.03 6.97 2.9a9.79 9.79 0 0 1 2.89 6.98c0 5.44-4.42 9.85-9.9 9.85zm5.4-7.38c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.16-.17.2-.35.22-.65.07-.3-.15-1.25-.46-2.38-1.47-.88-.79-1.47-1.76-1.64-2.06-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51l-.57-.01c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.06 2.87 1.21 3.07c.15.2 2.1 3.2 5.09 4.49.71.31 1.27.5 1.7.64.71.23 1.36.2 1.87.12.57-.09 1.75-.71 2-1.4.25-.68.25-1.27.17-1.4-.07-.13-.27-.2-.57-.35z"/>
  </svg>
);

const FloatingWhatsApp = () => {
  const { settings } = useSite();

  const url = settings.floating_whatsapp_url;
  if (!url || settings.floating_whatsapp_enabled === false) return null;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-button"
      title="Chatea con nosotros por WhatsApp"
      aria-label="Chatea con nosotros por WhatsApp"
      className="fixed bottom-24 right-4 sm:bottom-6 sm:right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#20b859] shadow-lg hover:shadow-xl flex items-center justify-center transition-all duration-200 active:scale-95 hover:scale-105"
    >
      <WhatsAppIcon className="w-8 h-8 text-white" />
      <span className="absolute top-0 right-0 w-3.5 h-3.5 bg-red-500 rounded-full border-2 border-white animate-pulse" />
    </a>
  );
};

export default FloatingWhatsApp;
